// Libraries
import React, { Fragment, useRef } from "react";
import { Camera } from "react-cam";
import useDeviceOrientation from "react-device-orientation-hook";
import ReactBeforeSliderComponent from "react-before-after-slider-component";

// Child Components
// import PrefixInput from "../common/form/prefixInput";

const Orientation = ({
  original,
  width,
  height,
  image,
  mask,
  capture,
  retake,
  getOrientation,
}) => {
  /*
  const {
    orientation,
    originOrientation,
    initialOrientation,
    transformStyle,
    resetPivotOrientation,
  } = useDeviceOrientation();
  */

  /*
  // Roun Degree Values Function
  function roundDegree(number) {
    return Math.round(number * 100) / 100;
  }
  */

  const { orientation, resetPivotOrientation } = useDeviceOrientation();

  // Orientation Event Handler
  const handleOrientation = () => {
    getOrientation(orientation);
  };

  const cam = useRef(null);

  const firstImage = {
    imageUrl: original,
  };
  const secondImage = {
    imageUrl: image,
  };

  return (
    <>
      <Fragment>
        {image ? (
          <ReactBeforeSliderComponent
            firstImage={firstImage}
            secondImage={secondImage}
          />
        ) : (
          <Fragment>
            {/*<div className="row align-items-center pb-2">
              <div className="col-sm-3">
                <button
                  className="btn btn-block btn-primary rounded"
                  onClick={resetPivotOrientation}
                >
                  Reset
                </button>
              </div> 
              <div className="col-sm-3">
                <PrefixInput
                  prefix={"Z-Axis"}
                  id={"alpha"}
                  type={"number"}
                  value={roundDegree(originOrientation.alpha)}
                />
              </div>
              <div className="col-sm-3">
                <PrefixInput
                  prefix={"X-Axis"}
                  id={"beta"}
                  type={"number"}
                  value={roundDegree(originOrientation.beta)}
                />
              </div>
              <div className="col-sm-3">
                <PrefixInput
                  prefix={"Y-Axis"}
                  id={"gamma"}
                  type={"number"}
                  value={roundDegree(originOrientation.gamma)}
                />
              </div>
            </div> */}

            <div className="wrap">
              <Camera
                showFocus={false}
                front={false}
                capture={capture}
                ref={cam}
                width={width}
                height={height}
                focusWidth="100%"
                focusHeight="100%"
                btnColor="yellow"
              />
              <div className="overlay">
                {mask && (
                  <img
                    className="o-img"
                    src={mask}
                    style={{ opacity: "0.5" }}
                    alt="..."
                  />
                )}
              </div>
            </div>
          </Fragment>
        )}

        <div className="row align-items-center pt-2 mt-1">
          <div className="col-sm-12">
            {image ? (
              <button
                className="btn btn-block btn-secondary rounded"
                onClick={(e) => retake(e)}
                onMouseDown={resetPivotOrientation}
              >
                Retake
              </button>
            ) : (
              <button
                className="btn btn-block btn-warning rounded"
                onClick={(img) => cam.current.capture(img)}
                onMouseDown={handleOrientation}
              >
                Capture
              </button>
            )}
          </div>
        </div>
      </Fragment>
    </>
  );
};
export default Orientation;
